import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";

import {
    BrowserRouter as Router,
    Switch,
    Route,
    useParams,
    useHistory, useLocation
} from "react-router-dom";
import {
    InstagramShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton, InstapaperIcon
} from "react-share";
import {HelmetProvider, Helmet} from 'react-helmet-async'
import {Swiper, SwiperSlide} from 'swiper/react';
import swiper, {Autoplay, Navigation, Pagination, EffectFade} from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import gsap, {CSSPlugin, TimelineLite} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

import Sticky from 'react-stickynode';
import {black, darkBlue, hover, text, white} from "../../styles/globalStyleVars";
import {Img} from "../../components/Img";
import Video from "../../components/Video";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {fetchProjectDetail} from "../../api/redux/project";
import ReactHtmlParser from "react-html-parser";
gsap.registerPlugin(CSSPlugin,ScrollTrigger);
const MyComponent = () => {

    const location = useLocation();

    const dispatch = useDispatch()
    const getData = useSelector(store => store.project)
    let {slug} = useParams();
    // api call
    useEffect(() => {
        let api_url = apiEndPoints.PROJECT_DETAIL
        dispatch(fetchProjectDetail([api_url + `/${slug}`]))
    }, [location.pathname])



    //variabls
    const sectionSingle = useRef(null);
    const detailsRef = useRef(null);

    // Run the effect when location.pathname changes

    useEffect(() => {
        document.querySelector('body').classList.add('details-page');
    },[location?.pathname])


    //sticky

    useEffect(() => {
        if(window?.innerWidth>767){
            gsap.to(".social-wrapper-main", {
                scrollTrigger: {
                    trigger: ".social-pin-wrapper",
                    start: "top top",
                    endTrigger: ".content-wrapper",
                    end: "bottom-=550px top",
                    pin: ".social-wrapper-main",
                    pinSpacing: false
                }
            });
        }
    }, []);


    const [shareUrl, setShareUrl] = useState('')
    useEffect(() => {
        setShareUrl(window.location.href)
    }, [])



    return (

        <HelmetProvider>
            {/*dynamic title */}
            <Helmet>
                <title>{`${ getData?.detail?.[0]?.meta?.meta_title ?  getData?.detail?.[0]?.meta?.meta_title : 'Projects | UCC Infrastructure Ltd.'}`}</title>
                <meta name="description"  content={getData?.detail?.[0]?.meta?.meta_desc ?  getData?.detail?.[0]?.meta?.meta_desc  :''}/>
                <meta property="og:title" content={`${getData?.detail?.[0]?.meta?.og_title ? getData?.detail?.[0]?.meta?.og_title : 'Projects | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:subtitle" content={`${getData?.detail?.[0]?.meta?.og_title ? getData?.detail?.[0]?.meta?.og_title : 'Projects | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:description" content={getData?.detail?.[0]?.meta?.og_desc ? getData?.detail?.[0]?.meta?.og_desc :''}/>
                <meta property="og:url" content={window?.location?.href}/>
                <meta property="og:image" content={getData?.detail?.[0]?.banner?.image}/>
                <meta property="og:type" content={"website"}/>

            </Helmet>

            <StyledComponent>
                <section id={'content'}  className="details-wrapper">
                    <Container>
                        <Row ref={detailsRef} className={'main-row'}>
                            {
                                window?.innerWidth>767 &&
                                <Col xs={12} md={3}  ref={sectionSingle}  className={'social-pin-wrapper'}>
                                    <div  className="social-wrapper-main">
                                        <p className="gray">Share:</p>
                                        <ul>
                                            <li className={'hover'}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="4.877" height="10.466"
                                                     viewBox="0 0 4.877 10.466">
                                                    <path id="Path_26" data-name="Path 26"
                                                          d="M1012.361,3918.425v-.9a1.965,1.965,0,0,1,.019-.315.612.612,0,0,1,.086-.219.351.351,0,0,1,.216-.149,1.551,1.551,0,0,1,.4-.041h.9V3915h-1.441a2.344,2.344,0,0,0-1.8.594,2.5,2.5,0,0,0-.546,1.75v1.086h-1.08v1.8h1.079v5.233h2.166v-5.233h1.442l.19-1.8Z"
                                                          transform="translate(-1009.116 -3914.995)" fill="#fff"/>
                                                </svg>
                                                <FacebookShareButton url={shareUrl}/>
                                            </li>
                                            <li className={'hover'}>
                                                <svg id="layer1" xmlns="http://www.w3.org/2000/svg" width="11.035" height="10.328" viewBox="0 0 11.035 10.328">
                                                    <path id="path1009" d="M281.527,167.31l4.26,5.7-4.287,4.632h.965l3.754-4.055,3.033,4.055h3.284l-4.5-6.017,3.991-4.311h-.965l-3.457,3.735-2.793-3.735Zm1.419.711h1.509l6.661,8.907h-1.509Z" transform="translate(-281.5 -167.31)" fill="#fff"/>
                                                </svg>

                                                <TwitterShareButton url={shareUrl}/>
                                            </li>
                                            {/*<li className={'hover'}>*/}
                                            {/*    <svg xmlns="http://www.w3.org/2000/svg" width="11.186" height="11.186" viewBox="0 0 11.186 11.186">*/}
                                            {/*        <g id="Group_13724" data-name="Group 13724" transform="translate(-2167 -9029)">*/}
                                            {/*            <path id="Path_5912" data-name="Path 5912" d="M5.593,1.008c1.493,0,1.67.006,2.26.033a3.093,3.093,0,0,1,1.038.193,1.733,1.733,0,0,1,.643.418,1.733,1.733,0,0,1,.418.643,3.1,3.1,0,0,1,.193,1.038c.027.59.033.767.033,2.26s-.006,1.67-.033,2.26a3.1,3.1,0,0,1-.193,1.038A1.852,1.852,0,0,1,8.891,9.953a3.093,3.093,0,0,1-1.038.193c-.59.027-.767.033-2.26.033s-1.67-.006-2.26-.033a3.093,3.093,0,0,1-1.038-.193,1.733,1.733,0,0,1-.643-.418,1.733,1.733,0,0,1-.418-.643A3.093,3.093,0,0,1,1.04,7.853c-.027-.59-.033-.767-.033-2.26s.006-1.67.033-2.26a3.093,3.093,0,0,1,.193-1.038,1.733,1.733,0,0,1,.418-.643,1.733,1.733,0,0,1,.643-.418A3.093,3.093,0,0,1,3.333,1.04c.59-.027.767-.033,2.26-.033M5.593,0C4.074,0,3.883.006,3.287.034a4.106,4.106,0,0,0-1.358.26A2.741,2.741,0,0,0,.939.939a2.741,2.741,0,0,0-.645.991,4.106,4.106,0,0,0-.26,1.358C.006,3.883,0,4.074,0,5.593S.006,7.3.034,7.9a4.106,4.106,0,0,0,.26,1.358,2.741,2.741,0,0,0,.645.991,2.743,2.743,0,0,0,.991.645,4.106,4.106,0,0,0,1.358.26c.6.027.787.034,2.306.034S7.3,11.179,7.9,11.152a4.106,4.106,0,0,0,1.358-.26,2.86,2.86,0,0,0,1.636-1.636,4.106,4.106,0,0,0,.26-1.358c.027-.6.034-.787.034-2.306s-.006-1.709-.034-2.306a4.106,4.106,0,0,0-.26-1.358,2.743,2.743,0,0,0-.645-.991A2.741,2.741,0,0,0,9.256.294,4.106,4.106,0,0,0,7.9.034C7.3.006,7.112,0,5.593,0" transform="translate(2167 9029)" fill="#fff"/>*/}
                                            {/*            <path id="Path_5913" data-name="Path 5913" d="M23.548,20.676a2.872,2.872,0,1,0,2.872,2.872,2.872,2.872,0,0,0-2.872-2.872m0,4.736a1.864,1.864,0,1,1,1.864-1.864,1.864,1.864,0,0,1-1.864,1.864" transform="translate(2149.045 9011.045)" fill="#fff"/>*/}
                                            {/*            <path id="Path_5914" data-name="Path 5914" d="M61.429,15.384a.671.671,0,1,1-.671-.671.671.671,0,0,1,.671.671" transform="translate(2114.82 9016.224)" fill="#fff"/>*/}
                                            {/*        </g>*/}
                                            {/*    </svg>*/}


                                            {/*    <FacebookShareButton url={shareUrl}/>*/}
                                            {/*</li>*/}


                                            <li className={'hover'}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="9.063" height="8.561"
                                                     viewBox="0 0 9.063 8.561">
                                                    <path id="LinkedIn"
                                                          d="M1096.5,3921.554v3.313h-1.942v-3.091c0-.776-.281-1.306-.984-1.306a1.061,1.061,0,0,0-1,.7,1.3,1.3,0,0,0-.065.469v3.226h-1.943s.026-5.234,0-5.777h1.943v.82l-.013.018h.013v-.018a1.932,1.932,0,0,1,1.751-.955C1095.539,3918.955,1096.5,3919.781,1096.5,3921.554Zm-7.964-5.249a1,1,0,1,0-.026,2h.013a1,1,0,1,0,.013-2Zm-.984,8.561h1.943v-5.777h-1.943Z"
                                                          transform="translate(-1087.435 -3916.306)" fill="#fff"/>
                                                </svg>
                                                <LinkedinShareButton url={shareUrl}/>
                                                {/*<InstapaperIcon url={shareUrl}/>*/}
                                            </li>
                                            {/*<li className={'hover'}>*/}
                                            {/*    <svg id="Group_31" data-name="Group 31" xmlns="http://www.w3.org/2000/svg" width="9.97" height="6.979" viewBox="0 0 9.97 6.979">*/}
                                            {/*        <path id="Path_29" data-name="Path 29" d="M1176.069,3919.422c-.36-.425-1.025-.6-2.294-.6h-4.606c-1.3,0-1.974.185-2.333.638a3.24,3.24,0,0,0-.349,1.993v1.717c0,1.745.415,2.631,2.682,2.631h4.606a2.913,2.913,0,0,0,2.1-.529,2.759,2.759,0,0,0,.577-2.1v-1.717A3.158,3.158,0,0,0,1176.069,3919.422Zm-3.181,3.128-2.092,1.087a.322.322,0,0,1-.47-.284v-2.168a.32.32,0,0,1,.154-.273.325.325,0,0,1,.315-.011l2.092,1.081a.319.319,0,0,1,0,.568Z" transform="translate(-1166.487 -3918.823)" fill="#fff"/>*/}
                                            {/*    </svg>*/}

                                            {/*    <TwitterShareButton url={shareUrl}/>*/}
                                            {/*</li>*/}
                                        </ul>
                                        {/*<SocialShare/>*/}
                                    </div>
                                </Col>
                            }
                            <Col xs={12} md={9} className={'content-wrapper'}>
                                <ul className="intro">
                                    <li>
                                        <p className="gray">{ReactHtmlParser(getData?.detail?.[0]?.type?.[0]?.name)}</p>
                                    </li>
                                    <li>
                                        <p className="gray">{ReactHtmlParser(getData?.detail?.[0]?.banner?.date)}</p>
                                    </li>
                                </ul>
                                <h1>
                                    {getData?.detail?.[0]?.post_title}
                                </h1>
                                <div>
                                    {/*{ReactHtmlParser(details?.post_content)}*/}
                                </div>
                                {

                                    <div className="banner img-group-caption">
                                        <div className="img-wrapper-big">
                                            <Img src={getData?.detail?.[0]?.banner?.image ? getData?.detail?.[0]?.banner?.image :'/images/static/default-thumb.svg'}/>
                                        </div>
                                    </div>
                                }

                                {
                                    window?.innerWidth<767 &&
                                    <>
                                        <div className={'mobile-social'}  >
                                            <p className="gray">Share:</p>
                                            <ul>
                                                <li className={'hover'}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="4.877" height="10.466"
                                                         viewBox="0 0 4.877 10.466">
                                                        <path id="Path_26" data-name="Path 26"
                                                              d="M1012.361,3918.425v-.9a1.965,1.965,0,0,1,.019-.315.612.612,0,0,1,.086-.219.351.351,0,0,1,.216-.149,1.551,1.551,0,0,1,.4-.041h.9V3915h-1.441a2.344,2.344,0,0,0-1.8.594,2.5,2.5,0,0,0-.546,1.75v1.086h-1.08v1.8h1.079v5.233h2.166v-5.233h1.442l.19-1.8Z"
                                                              transform="translate(-1009.116 -3914.995)" fill="#fff"/>
                                                    </svg>
                                                    <FacebookShareButton url={shareUrl}/>
                                                </li>
                                                <li className={'hover'}>
                                                    <svg id="layer1" xmlns="http://www.w3.org/2000/svg" width="11.035" height="10.328" viewBox="0 0 11.035 10.328">
                                                        <path id="path1009" d="M281.527,167.31l4.26,5.7-4.287,4.632h.965l3.754-4.055,3.033,4.055h3.284l-4.5-6.017,3.991-4.311h-.965l-3.457,3.735-2.793-3.735Zm1.419.711h1.509l6.661,8.907h-1.509Z" transform="translate(-281.5 -167.31)" fill="#fff"/>
                                                    </svg>

                                                    <FacebookShareButton url={shareUrl}/>
                                                </li>
                                                <li className={'hover'}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="11.186" height="11.186" viewBox="0 0 11.186 11.186">
                                                        <g id="Group_13724" data-name="Group 13724" transform="translate(-2167 -9029)">
                                                            <path id="Path_5912" data-name="Path 5912" d="M5.593,1.008c1.493,0,1.67.006,2.26.033a3.093,3.093,0,0,1,1.038.193,1.733,1.733,0,0,1,.643.418,1.733,1.733,0,0,1,.418.643,3.1,3.1,0,0,1,.193,1.038c.027.59.033.767.033,2.26s-.006,1.67-.033,2.26a3.1,3.1,0,0,1-.193,1.038A1.852,1.852,0,0,1,8.891,9.953a3.093,3.093,0,0,1-1.038.193c-.59.027-.767.033-2.26.033s-1.67-.006-2.26-.033a3.093,3.093,0,0,1-1.038-.193,1.733,1.733,0,0,1-.643-.418,1.733,1.733,0,0,1-.418-.643A3.093,3.093,0,0,1,1.04,7.853c-.027-.59-.033-.767-.033-2.26s.006-1.67.033-2.26a3.093,3.093,0,0,1,.193-1.038,1.733,1.733,0,0,1,.418-.643,1.733,1.733,0,0,1,.643-.418A3.093,3.093,0,0,1,3.333,1.04c.59-.027.767-.033,2.26-.033M5.593,0C4.074,0,3.883.006,3.287.034a4.106,4.106,0,0,0-1.358.26A2.741,2.741,0,0,0,.939.939a2.741,2.741,0,0,0-.645.991,4.106,4.106,0,0,0-.26,1.358C.006,3.883,0,4.074,0,5.593S.006,7.3.034,7.9a4.106,4.106,0,0,0,.26,1.358,2.741,2.741,0,0,0,.645.991,2.743,2.743,0,0,0,.991.645,4.106,4.106,0,0,0,1.358.26c.6.027.787.034,2.306.034S7.3,11.179,7.9,11.152a4.106,4.106,0,0,0,1.358-.26,2.86,2.86,0,0,0,1.636-1.636,4.106,4.106,0,0,0,.26-1.358c.027-.6.034-.787.034-2.306s-.006-1.709-.034-2.306a4.106,4.106,0,0,0-.26-1.358,2.743,2.743,0,0,0-.645-.991A2.741,2.741,0,0,0,9.256.294,4.106,4.106,0,0,0,7.9.034C7.3.006,7.112,0,5.593,0" transform="translate(2167 9029)" fill="#fff"/>
                                                            <path id="Path_5913" data-name="Path 5913" d="M23.548,20.676a2.872,2.872,0,1,0,2.872,2.872,2.872,2.872,0,0,0-2.872-2.872m0,4.736a1.864,1.864,0,1,1,1.864-1.864,1.864,1.864,0,0,1-1.864,1.864" transform="translate(2149.045 9011.045)" fill="#fff"/>
                                                            <path id="Path_5914" data-name="Path 5914" d="M61.429,15.384a.671.671,0,1,1-.671-.671.671.671,0,0,1,.671.671" transform="translate(2114.82 9016.224)" fill="#fff"/>
                                                        </g>
                                                    </svg>


                                                    <FacebookShareButton url={shareUrl}/>
                                                </li>


                                                <li className={'hover'}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9.063" height="8.561"
                                                         viewBox="0 0 9.063 8.561">
                                                        <path id="LinkedIn"
                                                              d="M1096.5,3921.554v3.313h-1.942v-3.091c0-.776-.281-1.306-.984-1.306a1.061,1.061,0,0,0-1,.7,1.3,1.3,0,0,0-.065.469v3.226h-1.943s.026-5.234,0-5.777h1.943v.82l-.013.018h.013v-.018a1.932,1.932,0,0,1,1.751-.955C1095.539,3918.955,1096.5,3919.781,1096.5,3921.554Zm-7.964-5.249a1,1,0,1,0-.026,2h.013a1,1,0,1,0,.013-2Zm-.984,8.561h1.943v-5.777h-1.943Z"
                                                              transform="translate(-1087.435 -3916.306)" fill="#fff"/>
                                                    </svg>
                                                    <LinkedinShareButton url={shareUrl}/>
                                                    {/*<InstapaperIcon url={shareUrl}/>*/}
                                                </li>
                                                <li className={'hover'}>
                                                    <svg id="Group_31" data-name="Group 31" xmlns="http://www.w3.org/2000/svg" width="9.97" height="6.979" viewBox="0 0 9.97 6.979">
                                                        <path id="Path_29" data-name="Path 29" d="M1176.069,3919.422c-.36-.425-1.025-.6-2.294-.6h-4.606c-1.3,0-1.974.185-2.333.638a3.24,3.24,0,0,0-.349,1.993v1.717c0,1.745.415,2.631,2.682,2.631h4.606a2.913,2.913,0,0,0,2.1-.529,2.759,2.759,0,0,0,.577-2.1v-1.717A3.158,3.158,0,0,0,1176.069,3919.422Zm-3.181,3.128-2.092,1.087a.322.322,0,0,1-.47-.284v-2.168a.32.32,0,0,1,.154-.273.325.325,0,0,1,.315-.011l2.092,1.081a.319.319,0,0,1,0,.568Z" transform="translate(-1166.487 -3918.823)" fill="#fff"/>
                                                    </svg>

                                                    <TwitterShareButton url={shareUrl}/>
                                                </li>
                                            </ul>
                                            {/*<SocialShare/>*/}
                                        </div>
                                    </>
                                }

                                {/*<p>[Excerpt] In today's fast-paced and interconnected world, embracing diversity has become more than just a buzzword—it has become a strategic imperative for success. </p>*/}
                                {/*<h3>[Section Title] Introduction</h3>*/}
                                {
                                    getData?.detail?.[0]?.text1?.list && getData?.detail?.[0]?.text1?.list?.length>0 &&
                                    getData?.detail?.[0]?.text1?.list?.map((element)=>{
                                        return(
                                            <>
                                                <h3>{ReactHtmlParser(element?.title)}</h3>
                                                {ReactHtmlParser(element?.description)}
                                            </>
                                        )
                                    })
                                }

                                {/*<p>Nowhere is this more evident than in our group of companies, where we celebrate the power of diversity and leverage the unique strengths of each industry to drive collective growth and innovation. In this blog, we will explore how the diverse portfolio of our group unlocks endless possibilities, fosters collaboration, and propels us forward as a force to be reckoned with.</p>*/}

                                {/*<ul className={'small-list'}>*/}
                                {/*    <li>Defining your financial objectives and timeline.</li>*/}
                                {/*    <li>Creating a comprehensive plan to achieve your goals</li>*/}
                                {/*    <li>Setting realistic expectations and benchmarks for success.</li>*/}
                                {/*</ul>*/}
                                {
                                    getData?.detail?.[0]?.description?.image &&
                                    <div className="img-group-caption">
                                        <div className="img-wrapper-big">
                                            <Img src={getData?.detail?.[0]?.description?.image}/>
                                        </div>
                                        {/*<p>[Excerpt] In today's fast-paced and interconnected world, embracing diversity has become more than just a buzzword—it has become a strategic imperative for success. </p>*/}
                                    </div>
                                }
                                {
                                    getData?.detail?.[0]?.description?.text &&
                                    <table>
                                        <tbody>
                                        {ReactHtmlParser(getData?.detail?.[0]?.description?.text)}
                                        </tbody>
                                    </table>
                                }


                                {
                                    getData?.detail?.[0]?.gallery?.list?.length>0 &&
                                    <div className="image-gallery-slider">

                                        <Swiper
                                            Swiper modules={[Autoplay, Pagination, Navigation, EffectFade]}
                                            slidesPerView={1}
                                            speed={1500}
                                            spaceBetween={50}
                                            draggable={true}
                                            navigation={{
                                                prevEl: '#details-prev',
                                                nextEl: '#details-next',
                                            }}
                                            loop={true}
                                        >

                                            {
                                                getData?.detail?.[0]?.gallery?.list && getData?.detail?.[0]?.gallery?.list?.length>0 &&
                                                getData?.detail?.[0]?.gallery?.list.map((element,index)=>{
                                                    return(
                                                        <SwiperSlide key={index}>
                                                            <div className="img-group-caption">
                                                                <div className="img-wrapper-big">
                                                                    <Img src={element?.image}/>
                                                                </div>
                                                                <p>{element?.title}</p>
                                                            </div>
                                                        </SwiperSlide>
                                                    )
                                                })
                                            }

                                        </Swiper>
                                        <div className="navigation"/>
                                    </div>
                                }

                                {
                                    getData?.detail?.[0]?.qoute?.text &&
                                    <div className={'split-up qoute'}>
                                        {ReactHtmlParser(getData?.detail?.[0]?.qoute?.text)}
                                    </div>
                                }
                                {/*<div className={'split-up qoute'}>*/}
                                {/*    <p>[Block Quote] The journey to financial independence begins with a clear*/}
                                {/*        destination*/}
                                {/*        in mind. Setting meaningful financial goals provides the foundation for building*/}
                                {/*        wealth and creating a roadmap to success. By crafting a comprehensive plan*/}
                                {/*        tailored*/}
                                {/*        to your aspirations, you can turn your dreams into actionable steps.</p>*/}
                                {/*    <span>- John Smith</span>*/}
                                {/*</div>*/}
                                {

                                    getData?.detail?.[0]?.video?.image &&
                                    <div className={'detail-video'}>
                                        <Video data={getData?.detail?.[0]?.video}/>
                                    </div>

                                }

                                {/*<VideoAnother poster={ 'blogs/details/blog_details_video_banner.jpg'} padding={''}/>*/}


                                {
                                    getData?.detail?.[0]?.text2?.list && getData?.detail?.[0]?.text2?.list?.length>0 &&
                                    getData?.detail?.[0]?.text2?.list?.map((element)=>{
                                        return(
                                            <>
                                                <h3>{ReactHtmlParser(element?.title)}</h3>
                                                {ReactHtmlParser(element?.description)}
                                            </>
                                        )
                                    })
                                }

                                {/*<h3>[Section Subtitle] Fueling Innovation through Cross-Pollination</h3>*/}
                                {/*<p>Within our group of companies, we have the distinct advantage of bringing together professionals from a wide range of industries, each with their own set of expertise and perspectives. This cross-pollination of ideas sparks innovation, as individuals from different backgrounds collaborate, challenge assumptions, and contribute fresh insights. By embracing diversity, we create a fertile ground for creativity and unlock the potential for groundbreaking solutions that transcend traditional boundaries.</p>*/}

                                {/*<ul className={'big-list'}>*/}
                                {/*    <li>*/}
                                {/*        True Professionals*/}
                                {/*        <p>{'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'}</p>*/}
                                {/*    </li>*/}
                                {/*    <li>*/}
                                {/*        Concise Strategies*/}
                                {/*        <p>{'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'}</p>*/}
                                {/*    </li>*/}
                                {/*    <li>*/}
                                {/*        Winning Mentality*/}
                                {/*        <p>{'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'}</p>*/}
                                {/*    </li>*/}
                                {/*    <li>*/}
                                {/*        Accessible Success*/}
                                {/*        <p>{'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'}</p>*/}
                                {/*    </li>*/}
                                {/*    <li>*/}
                                {/*        Embrace yourself*/}
                                {/*        <p>{'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'}</p>*/}
                                {/*    </li>*/}
                                {/*</ul>*/}
                                <div className="img-group-multiple">
                                    <Row>
                                        {
                                            getData?.detail?.[0]?.images?.big &&
                                            <Col md={12}>
                                                <div className="img-wrapper-big">
                                                    <Img src={getData?.detail?.[0]?.images?.big}/>
                                                </div>
                                            </Col>

                                        }
                                        {
                                            getData?.detail?.[0]?.images?.small1 &&
                                            <Col md={6}>
                                                <div className="img-wrapper-small">
                                                    <Img src={getData?.detail?.[0]?.images?.small1}/>
                                                </div>
                                            </Col>
                                        }
                                        {
                                            getData?.detail?.[0]?.images?.small2 &&
                                            <Col md={6}>
                                                <div className="img-wrapper-small">
                                                    <Img src={getData?.detail?.[0]?.images?.small2}/>
                                                </div>
                                            </Col>
                                        }
                                    </Row>
                                </div>
                                <h3>{getData?.detail?.[0]?.conclusion?.title}</h3>
                                <p>{getData?.detail?.[0]?.conclusion?.description}</p>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </StyledComponent>
        </HelmetProvider>

    );
};

const StyledComponent = styled.section`
    overflow: hidden;
    background: ${white};
    .mobile-social{
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
        ul{
            display: flex;
            li{
                width: 25px;
                height: 25px;
                border-radius: 50%;
                background-color: ${hover} ;
                margin-right: 8px;
                &:last-child{
                    margin-right: 0px !important;
                }
            }
        }

    }
    .qoute{
        margin-bottom: 60px;
        padding-left: 20px;
        border-left: 5px solid ${hover} ;
        p{
            margin-bottom: 40px !important;
        }

    }
    .detail-video{
        margin-bottom: 40px;
        .col-md-12{
            padding-left: 0px !important;
            padding-right: 0px !important;
        }
    }
    table{
        tr{
            &:last-child{
                td{
                    border-bottom: 1px solid transparent;
                }
            }
            th{
                padding-bottom: 20px;
                border-bottom: 1px solid ${black};
            }
            td{
                padding-bottom: 20px;
                padding-top: 20px;
                border-bottom: 1px solid ${text};
            }

        }
    }
    .details-wrapper {
        padding-top: 150px;
        overflow: hidden;
        .intro{
            margin-bottom: 30px;
        }

        .gray {
            color: ${text};
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            margin: 0 !important;

            p{
                margin: 0 !important;
            }
        }

        .social-pin-wrapper {
            /* Prevent GSAP from breaking flex layout */
            flex-shrink: 0 !important;

            .gray{
                margin-bottom: 30px !important;
            }
            ul {

                li {
                    min-height: 30px;
                    height: 30px;
                    width: 30px;
                    min-width: 30px;
                    border-radius: 50%;
                    background-color: ${darkBlue};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    margin-bottom: 20px;
                    position: relative;

                    button {
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        z-index: 2;
                    }

                    svg {
                        position: relative;
                        z-index: 2;
                    }
                }
                @media(max-width: 767px){
                    display: flex;
                }
            }

            //.social {
            //  flex-wrap: wrap;
            //  align-items: flex-start;
            //  justify-content: flex-start;
            //  flex-direction: column;
            //  gap: 20px;
            //
            //  li {
            //    margin-left: 0;
            //  }
            //}
        }

        .content-wrapper {
            padding-bottom: 140px;
            border-bottom: 1px solid #142637;
            .intro {
                display: flex;
                justify-content: space-between;
            }
            .video_body{
                margin-bottom: 60px;
                padding: 0 !important;
                margin-right: -15px;
                margin-left: -15px;
                background: transparent !important;
                &:after{
                    display: none !important;
                }
            }
            h1 {
                margin-bottom: 60px;
                font-size: 40px;
                font-weight: bold;
                line-height: 40px;
                color: ${darkBlue};
            }

            p {
                margin-bottom: 60px;
                color: ${darkBlue};
            }

            h3 {
                font-size: 24px;
                font-weight: bold;
                line-height: 28px;
                color: ${darkBlue};
                margin-bottom: 30px;
            }

            .small-list {
                margin-top: 0;
                list-style-type: none; /* Remove default list styles */
                padding: 0; /* Remove default padding */
                li {
                    position: relative;
                    padding-left: 20px; /* Adjust the space for the bullet */
                    //width: 8px;
                    //height: 8px;
                    padding-bottom: 20px;
                    padding-top: 20px;

                    &:not(:last-child){
                        border-bottom: 1px solid ${text};
                    }

                    &:before {
                        content: '\\2022'; /* Unicode character for a bullet point */
                        color: ${hover}; /* Set the color of the bullet */
                        //font-size: 1.2em; /* Adjust the size of the bullet */
                        position: absolute;
                        left: 0;
                        width: 8px;
                        height: 8px;
                    }
                    &:last-child{
                        margin-bottom: 40px;
                    }
                }
            }


            .big-list {
                margin-bottom: 60px;
                counter-reset: item;

                li {
                    position: relative;
                    padding-left: 40px; /* Adjust the space for the bullet */
                    padding-bottom: 20px;
                    padding-top: 20px;
                    list-style-type: none; /* Remove default numbering */

                    &:not(:last-child) {
                        border-bottom: 1px solid ${text};
                    }

                    &:before {
                        content: counter(item) ; /* Use counter to generate numbering */
                        counter-increment: item;
                        color: ${white}; /* Set the color of the bullet */
                        position: absolute;
                        left: 0;
                        width: 30px;
                        height: 30px;
                        background: ${hover};
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    &:last-child {
                        margin-bottom: 40px;
                    }

                    p {
                        margin-bottom: 0 !important;
                        text-transform: capitalize; /* Capitalize the first letter of each list item */
                    }
                }
            }
            .img-group-caption {
                margin-bottom: 60px;
                .img-wrapper-big {
                    position: relative;
                    padding-top: calc(520 / 870 * 100%);
                }

                p {
                    margin-top: 20px;
                }


                &.banner{
                    .img-wrapper-big{
                        padding-top: calc(400 / 870 * 100%);

                    }

                }
            }
            .img-group-multiple {
                margin-bottom: 40px;

                .img-wrapper-big {
                    position: relative;
                    padding-top: calc(520 / 870 * 100%);
                    margin-bottom: 30px;
                }
                .img-wrapper-small {
                    position: relative;
                    padding-top: calc(250 / 420 * 100%);
                }

            }

            table {
                margin-bottom: 40px;
            }

            .image-gallery-slider {
                position: relative;
                margin-bottom: 20px;

                .navigation {
                    position: absolute;
                    bottom: 55px;
                    right: 0;
                }

                .swiper-slide-active {
                    p {
                        transition-delay: 0.7s;
                        opacity: 1;
                    }
                }

                p {
                    opacity: 0;
                    transition: 0.7s all cubic-bezier(.54,.32,.05,.96);
                    max-width: 70%;
                    margin-top: 50px;
                }
            }

            blockquote {
                margin-bottom: 60px;
            }
            @media(max-width: 767px){
                h1{
                    font-size: 36px;
                }
            }
        }





    }


    //video style remove for grid 
    .video_body{
        .container{
            max-width: 100%;
            width: 100%;
            padding: 0;
            margin: 0;
            .row{
                margin: 0;
            }
        }
    }
    @media(max-width: 767px){
        .details-wrapper{
            padding-bottom: 120px;
            margin: 0 15px;
            .main-row{
                flex-direction: column-reverse;
            }
            .content-wrapper{
                padding: 0;
                .image-gallery-slider .navigation{
                    right: unset;
                    left: unset;
                    bottom: unset;
                    position: relative;
                }
            }
            .social-pin-wrapper {
                margin-top: 60px;
                padding: 0;
                .social {

                    flex-direction: row;
                    gap: 20px;

                    li {
                        margin-left: 0;
                    }
                }
            }


            .img-group-multiple{
                .col-md-6{
                    &:last-child{
                        margin-top: 30px;
                    }
                }
            }
        }
    }

`;

export default MyComponent;